var exports = {};

exports = function () {
  throw new Error("Not implemented.");
};

export default exports;